import React, {useState} from "react";
import { IconButton } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { EstimatesSearchModal } from "./estimates-search-modal";


const SearchPatientButton: React.FC = () => {
    const [searchPatientModalOpen, setSearchPatientModalOpen] = useState(false);

    const handleSearchModalCancel = () => {
        setSearchPatientModalOpen(false);
    }

    const updatePatientFormik = () => {
    }

    const updateVOBOnPatientSelection = () => {

    }

    const updateVobFormik = () => {

    }
    const handleEstimatorTabClick = () => {

    }


    return (
        <>
            <IconButton
                title="Search Patient"
                color="primary"
                style={{
                    fontSize: "1.8rem",
                    padding: "0px 10px 0 0",
                }}
                size="large"
                onClick={() => setSearchPatientModalOpen(true)}
                test-id="estimates-view-search-patient"
            >
                <PersonSearchIcon /> <strong>Search Patient</strong>
            </IconButton>
            {searchPatientModalOpen && (
                <EstimatesSearchModal
                    open={searchPatientModalOpen}
                    handlePatSearchModalCancel={handleSearchModalCancel}
                    handleUpdatePatientFormik={updatePatientFormik}
                    updateVOBOnPatientSelection={updateVOBOnPatientSelection}
                    handleUpdateVobFormik= {updateVobFormik}
                    handleEstimatorTabClick={handleEstimatorTabClick}
                />
            )}
        </>
    );
};

export default SearchPatientButton; 